import {
  Tooltip,
  XMarkIcon,
  useEffect,
  useCallback,
  useCanShow,
  ImportDataForm,
  DocumentArrowUpIcon,
} from "@";
function ImportData({ to, success }) {
  const handleKeyPress = useCallback((event) => {
    if (event.altKey && event.key === "m") {
      document.getElementById("import-data-btn").click();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <>
      {useCanShow("importData") && (
        <div>
          <button
            data-modal-target="import-data-modal"
            data-modal-toggle="import-data-modal"
            className="btn-white flex items-center justify-between"
            type="button"
          >
            <DocumentArrowUpIcon className="h-5 w-5" />
            <span className="ms-1 hidden lg:inline-block">
              استيراد من ملف اكسل
            </span>
          </button>

          <div
            tabIndex="-1"
            id="import-data-modal"
            aria-hidden="true"
            data-modal-backdrop="static"
            className="fixed left-0 right-0 top-0 z-50 hidden h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-y-auto overflow-x-hidden md:inset-0"
          >
            <div className="relative z-20 max-h-full w-full max-w-4xl p-1 md:p-4">
              <div className="relative rounded-2xl bg-white shadow dark:border dark:border-gray-600 dark:bg-gray-800">
                <div className="flex items-center justify-between rounded-t border-b p-4 dark:border-gray-700 md:p-5">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-400">
                    استيراد البيانات
                  </h3>
                  <button
                    type="button"
                    className="ms-auto inline-flex h-8 w-8 items-center justify-center rounded-2xl bg-transparent text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
                    data-modal-hide="import-data-modal"
                  >
                    <XMarkIcon className="h-7 w-7" />
                  </button>
                </div>
                <div className="space-y-4 p-4 md:p-5">
                  <ImportDataForm isSuccess={success} to={to} />
                </div>
              </div>
            </div>
            <div className="fixed inset-0 z-10 bg-gray-900 bg-opacity-50 backdrop-blur-[2px] dark:bg-opacity-60"></div>
          </div>
        </div>
      )}
    </>
  );
}

export default ImportData;
